import { render, staticRenderFns } from "./noResultsMenu.vue?vue&type=template&id=51dedd2d&scoped=true&"
import script from "./noResultsMenu.vue?vue&type=script&lang=js&"
export * from "./noResultsMenu.vue?vue&type=script&lang=js&"
import style0 from "./noResultsMenu.vue?vue&type=style&index=0&id=51dedd2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dedd2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
